




















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import * as firebase from 'firebase/app';
import Starred from "@/components/Starred.vue";
import {ESettori} from "@/types";

@Component({
    components: {Starred},
    computed: {
        ...mapGetters({profile: 'profile', isWorker: 'isWorker'})
    },
    name: "WorkerAnnouncement",
})
export default class WorkerAnnouncement extends Vue {
    esettori = ESettori;
    @Prop(Object) private readonly announcement!: any;
    @Prop({type: Boolean, default: false}) private readonly show_actions!: boolean;
    private profile?: any;
    private isWorker?: boolean;

    get isStarred() {
        return this.isWorker &&
            this.profile?.starredAnnouncements &&
            (this.profile.starredAnnouncements as string[]).indexOf(this.announcement.id) > -1
    }

    private toggleStarred(announcementUuid: string) {
        let starredAnnouncements: string[] = this.profile?.starredAnnouncements || [];

        if (starredAnnouncements.indexOf(announcementUuid) === -1) {
            starredAnnouncements.push(announcementUuid)
        } else {
            for (let i = starredAnnouncements.length - 1; i >= 0; i--) {
                if (starredAnnouncements[i] === announcementUuid) {
                    starredAnnouncements.splice(i, 1);
                }
            }
        }
        firebase.firestore().collection('users')
            .doc(this.profile.id).update({starredAnnouncements: starredAnnouncements})
    }

    private openAnnouncement() {
        this.$router.push({
            name: 'Announcement', params: {
                companyUuid: this.announcement.company.id, announcementUuid: this.announcement.id
            }
        })
    }

    get allowShare() {
        //@ts-ignore
        return navigator.share !== undefined;
    }


    private share() {

        //@ts-ignore
        navigator.share({
            title: 'JobToJob - ' + this.announcement.titolo,
            text: 'JobToJob - ' + this.announcement.descrizione,
            url: 'https://jobtojob.org/public_announcement/' + this.announcement.company.id + '/' + this.announcement.id
        })
            .then(() => {
            })
            .catch((err: any) => console.error(err));
    }
}

